import gql from 'graphql-tag';

export default gql`
  mutation create($type: String, $data: Json) {
    create(type: $type, data: $data) {
      document {
        type
        id
        deleted
        data
      }
      errors {
        field
        msg
      }
    }
  }
`;
